const drawFace = (face, size, max_width, index, account) => {
  let ratio = max_width / size["width"];
  let top = Math.round(face["top"] * ratio);
  let bottom = Math.round(face["bottom"] * ratio);
  let left = Math.round(face["left"] * ratio);
  let right = Math.round(face["right"] * ratio);
  let height = right - left;
  let width = bottom - top;
  let color = "red";
  if(account) {
      color = "green";
  } else {
      account = gettext("Неизвестный");
  }
  return `<div ng-click="openFace(fact, ${index})" style='position: absolute; cursor: pointer; border: 2px solid ${color}; top: ${top}px; left: ${left}px; height: ${height}px; width: ${width}px;'></div>` +
  `<div style='position: absolute; background-color: ${color}; color: white; font-size: 150%; top: ${top + height}px; left: ${left}px;'> ${account} </div>`;
}

export const decorateFaces = (val, fact) => {
  let faces = fact["faces"];
  if(!faces) return val;

  let bounds = faces["bounds"];
  if(!bounds || !bounds.length) return val;

  let accounts = faces["accounts"];

  val = "<div style='position: relative' width='480px'>" + val;
  for(let index = 0; index < bounds.length; index++) {
      val = val + drawFace( bounds[ index ], faces["size"], 480, index, accounts[index] );
  }
  return val + "</div>";
}


export const AssignDialogCtrl = function ($scope, $rootScope, $modalInstance, $http, $cookies, fact, index) {

  $scope.user_name = fact["agent_account.user_name"];

  $scope.ok = function (state) {
    $scope.loading = true;
    let data = {
        'account_id': fact['agent_account.id'],
        'fact_id': fact['id'],
        'assigned': state,
        'index': index,
        'faces': fact['faces'],
    }
    $http({
        url:'/face/assign/',
        method: "POST",
        data: data,
        headers: {
            "X-CSRFToken": $cookies.get('csrftoken'),
        },
    })
    .then(function () {
        $scope.loading = false;
        $modalInstance.close('ok');
        $rootScope.$broadcast('reload');
    })
  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };

};

export class FaceService {
    
    constructor($modal) {
        this.$modal = $modal;
    }

    openFace(fact, index) {
        this.$modal.open({
        template: require('./assign-face-modal.component.html'),
        controller: AssignDialogCtrl,
        scope: this.$scope,
        resolve: {
            fact: () => fact,
            index: () => index,
        },
      }).result
      .catch((err) => {
        console.error(err);
      });
    }
}




// WEBPACK FOOTER //
// ./src/face/face.service.js